import React, { useEffect, useRef, useState } from 'react';
import styles from './index.less';
import { Space, Tag, Tooltip } from 'antd';
import { PlusSquareOutlined } from '@ant-design/icons';
import type { IBaseComponentProps } from '@/types/baseComponent';
import PeopleRoleSelectContent from '@/components/PeopleRoleSelect/PeopleRoleSelectContent';
import Trigger from 'rc-trigger';
import cx from 'classnames';
import { PeopleRoleSelectContext } from '@/components/PeopleRoleSelect/context';
import type {
  SelectMember,
  SelectMemberMember,
  SelectRole,
  SelectRoleListItem,
} from '@/components/PeopleRoleSelect/SelectRoleOrMemberModal/types';
import { Modal } from 'antd';
import { useUpdateEffect } from 'ahooks';

interface TPeopleRoleSelectProps extends IBaseComponentProps {
  memberNodes?: SelectMember[];
  groupNodes?: SelectRole[];
  mode?: 'select' | 'modal';
  visible?: boolean;
  onClose?: () => void;
  disabled?: boolean;
  onChange?: (data: { roleList?: SelectRoleListItem[]; personList?: SelectMemberMember[] }) => void;
  onOk?: (memberNodes: SelectMember[], groupNodes: SelectRole[]) => void;
}

const PeopleRoleSelect: React.FC<TPeopleRoleSelectProps> = (props) => {
  const {
    groupNodes: outerGroupNodes,
    memberNodes: outerMemberNodes,
    onChange,
    visible,
    onClose,
    mode = 'modal',
    onOk,
    disabled,
  } = props;
  const [list, setList] = useState<{
    roleList?: SelectRoleListItem[];
    personList?: SelectMemberMember[];
  }>({
    roleList: undefined,
    personList: undefined,
  });

  const [memberNodes, setMemberNodes] = useState<SelectMember[]>([]);
  const [groupNodes, setGroupNodes] = useState<SelectRole[]>([]);
  const [open, setOpen] = useState(false);
  const [selectHeight, setSelectHeight] = useState(200);
  const [selectWidth, setSelectWidth] = useState(0);
  const wrapperRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   if (Array.isArray(props.memberNodes)) {
  //     setMemberNodes(props.memberNodes);
  //   }
  //   if (Array.isArray(props.groupNodes)) {
  //     setGroupNodes(props.groupNodes);
  //   }
  // }, [props]);

  useEffect(() => {
    if (Array.isArray(outerMemberNodes)) {
      setMemberNodes(outerMemberNodes);
    }
  }, [outerMemberNodes]);

  useEffect(() => {
    if (Array.isArray(outerGroupNodes)) {
      setGroupNodes(outerGroupNodes);
    }
  }, [outerGroupNodes]);

  useEffect(() => {
    if (open && wrapperRef.current !== null) {
      const dom = wrapperRef.current as HTMLDivElement;
      const rect = dom.getBoundingClientRect();
      // 48是下拉菜单头部的长度 10是预留的边距
      const calcSelectHeight = document.body.offsetHeight - rect.bottom - 48 - 10;
      setSelectWidth(dom.clientWidth);
      // 500 是下拉框的最大长度
      setSelectHeight(calcSelectHeight > 500 ? 500 : calcSelectHeight);
    }
  }, [open]);
  useUpdateEffect(() => {
    console.log('list是');
    console.log(list);
    onChange?.(list);
  }, [list]);
  const handleChangeNodes = (type: 'member' | 'groups', data: (SelectMember | SelectRole)[]) => {
    console.log('handleChangeNodes nodes是');
    console.log(data);
    if (type === 'member') {
      setMemberNodes(data as SelectMember[]);
      const temp = {
        personList: data.map((item) => {
          return {
            pernr: item.id,
            nameEn: item.completeName.split('-')[0],
            nameZh: item.completeName.split('-')[1],
          };
        }),
        roleList: groupNodes.map((item) => {
          return {
            id: item.id,
            name: item.completeName,
          };
        }),
      };
      setList(temp);
    } else {
      setGroupNodes(data as SelectRole[]);
      const temp = {
        personList: memberNodes.map((item) => {
          return {
            pernr: item.id,
            nameEn: item.completeName.split('-')[0],
            nameZh: item.completeName.split('-')[1],
          };
        }),
        roleList: data.map((item) => {
          return {
            id: item.id,
            name: item.completeName,
          };
        }),
      };
      setList(temp);
    }
  };
  const isEmpty = () => {
    return groupNodes.length === 0 && memberNodes.length === 0;
  };
  const renderNodes = () => {
    const memberCom = memberNodes.map((node) => {
      return (
        <Tag
          id={node.id}
          key={node.id}
          closable={!disabled}
          onClose={() => {
            if (disabled) {
              return;
            }
            const findIdx = memberNodes.findIndex((item) => item.id === node.id);
            if (findIdx > -1) {
              setMemberNodes((prevState) => {
                prevState.splice(findIdx, 1);
                handleChangeNodes('member', [...prevState]);
                return [...prevState];
              });
            }
          }}
        >
          {node.completeName}
        </Tag>
      );
    });
    const groupsCom = groupNodes.map((node) => {
      return (
        <Tag
          id={String(node.id)}
          key={node.id}
          closable={!disabled}
          onClose={() => {
            if (disabled) {
              return;
            }
            const findIdx = groupNodes.findIndex((item) => item.id === node.id);
            if (findIdx > -1) {
              setGroupNodes((prevState) => {
                prevState.splice(findIdx, 1);
                handleChangeNodes('groups', [...prevState]);
                return [...prevState];
              });
            }
          }}
        >
          {node.name}
        </Tag>
      );
    });
    return memberCom.concat(groupsCom);
  };
  const renderContentByMode = () => {
    const dom = (
      <div className={cx(styles.people_role_select, disabled && styles.disabled)} ref={wrapperRef}>
        <Trigger
          action={['click']}
          onPopupVisibleChange={(tempvisible) => {
            if (disabled) {
              setOpen(false);
            } else {
              setOpen(tempvisible);
            }
          }}
          popupVisible={disabled ? false : open}
          popupAlign={{
            points: ['tl', 'bl'],
            offset: [0, 3],
          }}
          // getPopupContainer={(trigger) => {
          //   return trigger.parentNode as any;
          // }}
          popup={<PeopleRoleSelectContent selectWidth={selectWidth} />}
        >
          <div className={cx(styles.people_role_select_body, isEmpty() && styles.no_member)}>
            {isEmpty() ? (
              <Space className="text-808696 cursor-pointer">
                <PlusSquareOutlined />
                点击选择成员
              </Space>
            ) : (
              <React.Fragment>{renderNodes()}</React.Fragment>
            )}
          </div>
        </Trigger>
      </div>
    );
    if (mode === 'select') {
      return (
        <React.Fragment>
          {!disabled ? dom : <Tooltip title="仅管理员可设置">{dom}</Tooltip>}
        </React.Fragment>
      );
    }
    return (
      <Modal
        open={visible}
        onCancel={onClose}
        onOk={() => {
          onOk?.(memberNodes, groupNodes);
        }}
        title="添加人员"
        width={900}
        okText="保存"
        okButtonProps={{ disabled: isEmpty() }}
        cancelText={'取消'}
      >
        <PeopleRoleSelectContent />
      </Modal>
    );
  };
  return (
    <PeopleRoleSelectContext.Provider
      value={{ memberNodes, groupNodes, changeNodes: handleChangeNodes, selectHeight, mode }}
    >
      {renderContentByMode()}
    </PeopleRoleSelectContext.Provider>
  );
};
export default PeopleRoleSelect;
